import { UserEngagementNotificationData } from "@cruisen/contract"
import styles from "./styles.module.scss"
import { ErrorHandledImage } from "../../../atoms/ErrorHandledImage"
import { _t } from "@cruisen/i18n"
import classNames from "classnames"
import { handleNotificationAction } from "../../../../services/notifications-navigation"

export const UserEngagement = ({
  message,
  data,
}: {
  message: string
  data: UserEngagementNotificationData
}) => {
  const { imageUrl, ctaButtonUrl, ctaButtonActionId, ctaButtonText, title } = data

  const goTo = () => {
    if (ctaButtonActionId) {
      handleNotificationAction({ id: ctaButtonActionId }, data)
    } else if (ctaButtonUrl) {
      handleNotificationAction({ id: "openLinkInBrowser", url: ctaButtonUrl }, data)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.box}>
        {imageUrl && (
          <ErrorHandledImage
            className={styles.image}
            uri={imageUrl}
            errorMessage={_t("imageError.generic")}
          />
        )}
        <div className={classNames(styles.column, imageUrl ? "" : styles.noImage)}>
          {title && <p className={styles.title}>{title}</p>}
          <p className={styles.message}>{message}</p>
          {ctaButtonUrl && (
            <button className={styles.actionButton} onClick={goTo}>
              {ctaButtonText ?? _t("common.view")}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
